import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LinkedWebsite {
  name: string;
  api_token: string;
}

export interface LinkedWebsiteListInfor {
  errors: unknown;
  linkedWebsite: LinkedWebsite;
  isAuthenticated: boolean;
}

@Module
export default class LinkedWebsiteModule
  extends VuexModule
  implements LinkedWebsiteListInfor
{
  errors = {};
  linkedWebsite = {} as LinkedWebsite;
  isAuthenticated = !!JwtService.getToken();

  get LinkedWebsites() {
    return this.linkedWebsiteListData;
  }

  @Mutation
  [Mutations.LINKED_WEBSITE_LIST_DATA](LinkedWebsites) {
    this.linkedWebsiteListData = LinkedWebsites;
  }

  @Action
  [Actions.LINKED_WEBSITE_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("linked_websites/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.LINKED_WEBSITE_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LINKED_WEBSITE_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("linked_websites", payload)
        .then((data) => {
          this.context.commit(Mutations.LINKED_WEBSITE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LINKED_WEBSITE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/linked_websites",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.LINKED_WEBSITE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LINKED_WEBSITE_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/linked_websites", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.LINKED_WEBSITE_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
